import React, { useRef, useEffect, useState } from "react";
import Header from "../../layouts/Header";
import bin from "../../assets/icons/Bin2.svg";
import cross2 from "../../assets/icons/Xicon.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import Package from "../../assets/icons/package.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import { Image } from "react-bootstrap";
import { ProductDropdown } from "../../redux/actions/action";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { ROLES } from "../../utils/helpers/userRole";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { SyncOutlined } from "@ant-design/icons";
import { quoteProductState } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const QuoteProductService = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { quoteId } = useParams();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Quotes").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [parts, setParts] = useState([]);
  const [productList, setProductList] = useState([]);
  const [fullProductList, setFullProductList] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [totalizeAmountInSectionHeader, setTotalizeAmountInSectionHeader] =
    useState(1);

  const { fetchProductDropdown, quoteProducts } = useSelector(
    (state) => state.user,
  );

  const handleAdd = () => {
    localStorage.setItem("quoteBlockNavigation", "yes");
    const { sections, index, sectionIndex, activeTab, quoteDetails } =
      quoteProducts;
    const list = Array.from(sections);
    list.forEach((section, ind) => {
      if (ind === sectionIndex) {
        section?.subSections?.forEach((subSection, i) => {
          if (i === index) {
            subSection.total = parts.reduce(
              (total, part) => +part.total + total,
              0,
            );
            subSection.subSectionParts = parts;
            subSection.totalizeAmountInSectionHeader =
              totalizeAmountInSectionHeader;
          }
        });
      }
    });
    dispatch(
      quoteProductState({
        sections: [...list],
        action: "add",
        activeTab,
        quoteDetails,
      }),
    );
    history.goBack();
  };

  const handleCancel = () => {
    const { sections, activeTab, quoteDetails } = quoteProducts;
    dispatch(
      quoteProductState({ sections, action: "add", activeTab, quoteDetails }),
    );
    history.goBack();
  };

  useEffect(() => {
    if (Object.keys(quoteProducts)?.length === 0) return history.goBack();
    setParts(quoteProducts?.subSectionParts);
    setTotalizeAmountInSectionHeader(
      quoteProducts?.totalizeAmountInSectionHeader,
    );
  }, [quoteProducts]);

  useEffect(() => {
    if (fetchProductDropdown?.status === true) {
      setShowLoader(false);
      setProductList(fetchProductDropdown?.data);
      setFullProductList(fetchProductDropdown?.data);
    }
  }, [fetchProductDropdown]);

  useEffect(() => {
    dispatch(ProductDropdown());
  }, []);

  return (
    <>
      <Header />
      <div className="quote-n-id-box">
        <div className="frcb" style={{ flexWrap: "wrap", gap: "1rem" }}>
          <div className="frc" style={{ columnGap: "14px" }}>
            <div
              className="quote-n-product-checkbox"
              style={{
                background: totalizeAmountInSectionHeader
                  ? "linear-gradient(179deg, #00246A, #95A7C6)"
                  : "white",
                border: totalizeAmountInSectionHeader
                  ? ""
                  : "0.5px solid #00000026",
              }}
              onClick={() =>
                setTotalizeAmountInSectionHeader(
                  totalizeAmountInSectionHeader === 0 ? 1 : 0,
                )
              }
            ></div>
            <p className="quote-n-product-check-text">
              {/* Totalize amount in section header */}
              {t("Totalize amount in section header")}
            </p>
          </div>
          <div className="frc" style={{ columnGap: "1rem" }}>
            <button className="cal-page-cancel" onClick={handleCancel}>
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="cal-page-change"
              style={{ backgroundColor: "#00246A" }}
              onClick={handleAdd}
            >
              {/* Add */}
              {t("Add")}
            </button>
          </div>
        </div>
        <div className="quote-n-product-table">
          <div className="quote-n-product-table-head">
            <p>
              {/* Item Description */}
              {t("Item Description")}
            </p>
            <p>
              {/* Measure Unit */}
              {t("Measure Unit")}
            </p>
            <p>
              {/* Unit Price */}
              {t("Unit Price")}
            </p>
            <p>
              {/* Qty. */}
              {t("Qty")}
            </p>
            <p>
              {/* Total */}
              {t("Total")}
            </p>
          </div>
          {parts?.map((part, index) => {
            return (
              <SingleProduct
                key={index}
                part={part}
                setParts={setParts}
                index={index}
                parts={parts}
              />
            );
          })}
          <AddProduct
            productList={productList}
            fullProductList={fullProductList}
            setProductList={setProductList}
            parts={parts}
            setParts={setParts}
            FetchTranslationList={FetchTranslationList}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
          />
        </div>
      </div>
    </>
  );
};

const SingleProduct = ({ part, setParts, index, parts }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    let list = [...parts];
    list[index][name] = value;
    // list[index][name] = name === "qty" ? Math.floor(+value) : value;
    if (name === "qty")
      list[index]["total"] = +list[index]["unitPrice"] * +value;
    setParts([...list]);
  };

  const handleDelete = () => {
    let list = [...parts];
    list.splice(index, 1);
    setParts([...list]);
  };
  return (
    <div className="quote-n-product-table-body">
      <div className="quote-n-product-table-content">
        <p>{part?.productPartName}</p>
        <input
          style={{ border: "none" }}
          value={part?.measureUnit}
          name="measureUnit"
          onChange={handleChange}
          type="text"
        />
        <p>{europeanFormatWithSymbol(+part?.unitPrice)}</p>
        <input
          style={{ border: "none" }}
          value={part?.qty}
          type="number"
          name="qty"
          onChange={handleChange}
          placeholder="0"
        />
        <p>{europeanFormatWithSymbol(+part?.total)}</p>
      </div>
      <div>
        <img src={bin} width={17} height={18} onClick={handleDelete} />
      </div>
    </div>
  );
};

const AddProduct = ({
  productList,
  fullProductList,
  setProductList,
  parts,
  setParts,
  FetchTranslationList,
  showLoader,
}) => {
  const roleAccess = window.localStorage.getItem("roleid");
  const materialPopupRef = useRef(null);
  const [showMaterialPopup, setShowMaterialPopup] = useState(false);
  const [selectedParts, setSelectedParts] = useState([]);
  const [material, setMaterial] = useState("");
  const materialInputRef = useRef(null);
  const packageId = window.localStorage.getItem("packageId");
  const t = (key) => FetchTranslationList?.[key] || "";

  const handleCheck = (index) => {
    let list = [...selectedParts];
    let found;
    list?.length > 0
      ? (found = list.findIndex(
          (prod) => prod.productPartid === productList[index].productPartid,
        ))
      : (found = false);
    if (found >= 0 && found !== false) {
      list.splice(found, 1);
      return setSelectedParts([...list]);
    }
    let item = {
      productPartid: productList[index]?.productPartid,
      measureUnit: productList[index]?.unit,
      qty: 0,
      // unitPrice: Number(productList[index]?.salePriceexcvat),
      unitPrice:
        parseFloat(
          String(productList[index]?.salePriceexcvat).replace(",", "."),
        ) || 0,
      total: 0,
      productPartName: productList[index]?.productPartName,
    };
    list.push(item);
    setSelectedParts([...list]);
  };

  const handleAddProduct = () => {
    if (roleAccess === ROLES.VIEWER)
      return handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `You don't have permission to add/edit quotes.`,
      });
    let list = [...selectedParts];
    list.map(
      (item, index) => (item["indexPosition"] = parts?.length + index + 1),
    );
    setParts((part) => [...part, ...list]);
    setMaterial("");
    setSelectedParts([]);
    setShowMaterialPopup(false);
  };

  useEffect(() => {
    if (material) {
      let list = [...fullProductList];
      list = list?.filter((product) => {
        return (
          product?.productPartName
            ?.toLowerCase()
            .includes(material.toLowerCase()) ||
          product?.productPartCode
            ?.toLowerCase()
            .includes(material.toLowerCase()) ||
          product?.itemdescription
            .toLowerCase()
            .includes(material.toLowerCase()) ||
          // supplier name and item id searching
          product.supplier?.some(
            (supplier) =>
              supplier.productpartcode
                ?.toLowerCase()
                .includes(material.toLowerCase()) ||
              supplier.suppliername
                ?.toLowerCase()
                .includes(material.toLowerCase()) ||
              supplier.itemid?.toLowerCase().includes(material.toLowerCase()),
          )
        );
      });
      setProductList(list);
    } else {
      setProductList([...fullProductList]);
    }
  }, [material]);

  useEffect(() => {
    if (showMaterialPopup) {
      materialInputRef.current.focus();
    }
  }, [showMaterialPopup]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        materialPopupRef.current &&
        !materialPopupRef.current.contains(event.target)
      ) {
        setShowMaterialPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [materialPopupRef]);

  return (
    <div className="quote-n-product-table-body">
      <div
        className="quote-n-product-table-content"
        style={{ position: "relative" }}
      >
        <p
          style={{ color: "#9A9999", cursor: "pointer" }}
          onClick={() => setShowMaterialPopup(true)}
        >
          {/* Type an item */}
          {t("Type an item")}
        </p>
        <div
          ref={materialPopupRef}
          className="material-popup p-0"
          style={{
            transform: showMaterialPopup ? "scale(1)" : "scale(0)",
            transitionDuration: "300ms",
            position: "fixed",
            top: "150px",
            left: "15%",
          }}
        >
          <div className="d-flex justify-content-between align-items-center bgdiv">
            <p className="inputparts px-3">Parts</p>
            <div className="add-order w-100">
              <input
                className="update-member-input-noborder add-member-input bgforinput w-100"
                value={material}
                onChange={(e) => setMaterial(e.target.value)}
                autoFocus
                ref={materialInputRef}
                // placeholder="Search ... "
                placeholder={FetchTranslationList[26]?.translation}
              />
            </div>
            <img
              src={DelIcon}
              alt=""
              className="mx-3 cursor-pointer"
              onClick={() => {
                setShowMaterialPopup(false);
                setMaterial("");
              }}
            />
          </div>

          <div className="material-items p-3 d-block border-0">
            {showLoader && (
              <p className="">
                please wait while we fetching your data... &nbsp;{" "}
                <SyncOutlined spin />
              </p>
            )}

            {productList?.map((product, index) => {
              return (
                <div
                  class="d-flex align-items-center gap-3 pointer"
                  key={index}
                  onClick={() => handleCheck(index)}
                  style={{ borderTop: "1px dashed #7e7e7e" }}
                >
                  <div
                    className="material-checkbox"
                    style={{
                      backgroundColor: selectedParts?.find(
                        (product2) =>
                          product2.productPartid === product?.productPartid,
                      )
                        ? "#004289"
                        : "transparent",
                      boxShadow: selectedParts?.find(
                        (product2) =>
                          product2.productPartid === product?.productPartid,
                      )
                        ? "0px 3px 6px #34394b29"
                        : "none",
                    }}
                  ></div>

                  <p
                    className="single-material-item-text ps-4 w-50"
                    style={{
                      textTransform: "capitalize",
                      textAlign: "start",
                    }}
                  >
                    {product?.productPartName}
                  </p>

                  {packageId === process.env.REACT_APP_IS_PREMIUM ? (
                    <div className="desc-image-wrp1 desc-image1 ">
                      {product?.cover ? (
                        <>
                          <div
                            className={`product-list-image-default1 ${
                              product?.image.length === 0 ? "hover-hide1" : ""
                            }`}
                          >
                            <img
                              src={product?.cover}
                              alt=""
                              className="cover-image1"
                            />
                            {product?.image && product?.image.length > 0 && (
                              <div className="image-row1">
                                {product?.image
                                  .slice(0, 3)
                                  .map((val, index) => (
                                    <img
                                      key={index}
                                      src={val}
                                      alt={`Images ${index + 1}`}
                                    />
                                  ))}
                              </div>
                            )}
                          </div>
                          {product?.image && product?.image.length > 0 && (
                            <span className="desc-image-plus1">
                              <Image
                                height={10}
                                width={10}
                                src={plusBorderWhite}
                              />
                            </span>
                          )}
                        </>
                      ) : (
                        <div className="product-list-default1">
                          <img src={Package} alt="" className="default-img1" />
                          <div className="product-image-title d-none">
                            {/* Picture */}
                            {FetchTranslationList[66]?.translation}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="single-material-item-right ps-3">
                    <p className="sm-item-title">Stock</p>
                  </div>

                  {!product?.supplier?.length === 0 ? (
                    <div className="sm-empty-stock">
                      <p>-</p>
                      <div
                        className="material-checkbox"
                        style={{
                          backgroundColor: "transparent",
                          boxShadow: "none",
                        }}
                      ></div>
                    </div>
                  ) : (
                    <div className="mt-1">
                      <div className="s-m-stock-div">
                        <div
                          className="sm-stock-color"
                          style={{
                            backgroundColor: `${product?.color}`,
                          }}
                        ></div>
                        <div className="sm-stock ps-2">
                          <p className="sm-stock-text">{product?.instock}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div style={{ textAlign: "center" }}>
            <button className="material-add-btn" onClick={handleAddProduct}>
              {/* Add */}
              {t("Add")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteProductService;
